import Vue from 'vue'

export const login = data => Vue.axios.post('auth/login', data)
export const logout = () => destroyToken()
export const getProfile = () => Vue.axios.get('me')
export const updatePolicy = (id, data) => Vue.axios.put(`users/${id}/updatePolicy`, data)

export const registerUser = data => Vue.axios.post('users', data)
export const updateUser = (id, data) => Vue.axios.put(`users/${id}`, data)
export const searchUsers = email => Vue.axios.post('users/search', { email })
export const deleteUser = (id, reason) => Vue.axios({
  method: 'delete',
  url: `users/${id}`,
  data: { reason }
})

export const sendPasswordReset = email => Vue.axios.post(`users/${email}/resetPassword`)
export const resetPassword = (email, data) => Vue.axios.put(`users/${email}/resetPassword`, data)

export const activateEmail = (email, data) => Vue.axios.put(`users/${email}/activate`, data)
export const changeEmail = (id, email) => Vue.axios.post(`users/${id}/${email}`)

export const getAdvertisingBidSessions = (id, data) => Vue.axios.get(`users/${id}/advertising/bidSessions`)
export const getBiddingBidSessions = (id, data) => Vue.axios.get(`users/${id}/bidding/bidSessions`)

export const getRatingsReceived = id => Vue.axios.get(`users/${id}/ratings/received`)
export const getRatingsGiven = id => Vue.axios.get(`users/${id}/ratings/given`)

export const getToken = () => window.localStorage.getItem('ms.token')
export const saveToken = token => window.localStorage.setItem('ms.token', token)
export const destroyToken = () => window.localStorage.removeItem('ms.token')



// WEBPACK FOOTER //
// ./src/services/users.js